import { createRouter, createWebHistory } from "vue-router";
// @ts-ignore
import { UserStore } from "../stores/userStore";
// @ts-ignore
import { ProfileStore } from "@/stores/profileStore";
// import { routes } from "./routes";
// import { appRoutes } from "./appRoutes";
import axios from "axios";
// @ts-ignore
import { i18n } from "@/functional/languages";

// @ts-ignore
import Redirections from "@/router/routes/redirections";

// @ts-ignore
import Trends from "@/router/routes/trends";

// const combinedRoutes = [...routes, ...appRoutes];

import routes from "./routes/index";

// @ts-ignore
import { FlixlatinoApiClient } from "@/services/FlixlatinoApiClient";
import Util from "../services/Util";

const allRoutes = [
  ...Trends,
  ...Redirections,
  {
    path: "/:locale?",
    children: routes,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
});

const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.scrollTo(0, 0);
  }
};

const setAxiosToken = (token: string) => {
  if (!axios.defaults.params) {
    axios.defaults.params = {};
  }
  axios.defaults.params["token"] = token;
};

router.afterEach(() => {
  scrollToTop();
});
router.beforeEach((to, from, next) => {
  const userStore = UserStore();
  const profileStore = ProfileStore();
  const apiClient = new FlixlatinoApiClient();

  const setDefaultProfile = async () => {
    apiClient.getProfiles().then((response: any) => {
      if (response) {
        if (userStore.trialEntitlement) {
          profileStore.setProfiles(response.profiles.all);
          apiClient
            .getInitData(profileStore.getProfiles[0], userStore.getLanguage)
            .then(() => {
              profileStore.setCurrentProfile(profileStore.getProfiles[0]);
            });
        }
      }
    });
  };

  const resolveLocale = () => {
    const storeLocale = String(userStore.selectedLanguage || userStore.getLanguage || "").toLowerCase();
    if (["es", "en"].includes(storeLocale)) {
      return storeLocale;
    }

    if (typeof window !== "undefined") {
      const browserLocale = String(
        window.navigator?.language || window.navigator?.languages?.[0] || ""
      ).toLowerCase();
      if (browserLocale.startsWith("en")) {
        return "en";
      }
      if (browserLocale.startsWith("es")) {
        return "es";
      }
    }

    return "es";
  };

  const localeParam = typeof to.params.locale === "string" ? to.params.locale : "";
  if (!localeParam) {
    const resolvedLocale = resolveLocale();
    const isRootRequest = to.path === "/" || to.path === "";

    if (isRootRequest) {
      const localePath = `/${resolvedLocale}/`;

      if (typeof window !== "undefined") {
        const search = window.location.search || "";
        const hash = window.location.hash || "";
        window.location.replace(`${localePath}${search}${hash}`);
        next(false);
        return;
      }

      next({
        path: localePath,
        query: to.query,
        hash: to.hash,
        replace: true,
      });
      return;
    }

    if (to.name) {
      next({
        name: String(to.name),
        params: { ...to.params, locale: resolvedLocale },
        query: to.query,
        hash: to.hash,
        replace: true,
      });
      return;
    }

    const normalizedPath = to.path.startsWith("/") ? to.path : `/${to.path}`;
    next({
      path: `/${resolvedLocale}${normalizedPath}`,
      query: to.query,
      hash: to.hash,
      replace: true,
    });
    return;
  } else if (localeParam === "es" || localeParam === "en") {
    userStore.setLanguage(localeParam);
  }

  /*if (to.name === "country-movies" && to.path.includes("country-movies")) {
    if (to.params.locale === "es") {
      next({
        path: `/es/descubre/${to.params.country}`,
      });
    } else {
      next({
        path: `/en/discover/${to.params.country}`,
      });
    }
  }*/

  i18n.locale = to.params.locale;
  axios.defaults.params["lang"] = to.params.locale;

  if (
    to.query["l"] !== undefined &&
    to.query["l"] !== null &&
    to.query["l"] === "reset_password"
  ) {
    const resetPasswordPath =
      to.query["lang"] === "en" ? "/reset-password/" : "/reiniciar-contrasena/";
    next({
      path:
        to.query["lang"] +
        resetPasswordPath +
        to.query["q"] +
        "/" +
        to.query["email"],
    });
    return;
  }

  if (to.path.toLowerCase() !== to.path) {
    next({
      path: to.path.toLowerCase(),
      query: to.query,
      hash: to.hash,
      replace: true,
    });
    return;
  }

  if (typeof to.meta.lang !== "undefined") {
    axios.defaults.params = {};
    axios.defaults.params["lang"] = to.meta.lang;
  }

  if (typeof userStore.isEntitled === "undefined") {
    setAxiosToken(userStore.getToken);
  }

  const bypassPlansAfterMagicLink =
    typeof window !== "undefined" &&
    window.localStorage.getItem("flx:magic-link:bypass-plans") === "1";

  if (
    userStore.isLoggedIn &&
    userStore.trialEntitlement &&
    !["plans-logged", "checkout", "logout", "link", "linkCode"].includes(
      <string>to.name
    )
  ) {
    if (!bypassPlansAfterMagicLink) {
      next({
        name: "plans-logged",
        params: { locale: userStore.getLanguage || localeParam || "es" },
      });
      return;
    }
  }

  if (
    !profileStore.isProfileSelected &&
    userStore.isLoggedIn &&
    !userStore.trialEntitlement &&
    !["profiles", "link", "linkCode", "plans-logged", "checkout"].includes(
      <string>to.name
    )
  ) {
    next({
      name: "profiles",
      params: { locale: userStore.getLanguage || localeParam || "es" },
    });
    return;
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !userStore.isLoggedIn
  ) {
    // console.info("User is not logged in, redirecting to login page", from, to);

    if (to.name === "checkout") {
      next({ name: "register", params: { locale: userStore.getLanguage || localeParam || "es" }, query: {nextUrl: to.fullPath} });
    } else {
      if (from.meta.entrypoint) {
        userStore.setEntrypoint(to.fullPath);
      }

      if (to.fullPath.includes("to_register")) {
        userStore.setEntrypoint(
          Util.removeParamFromPath(to.fullPath, "to_register")
        );
        next({ name: "register", params: { locale: userStore.getLanguage || localeParam || "es" } });
      } else {
        userStore.setEntrypoint(to.fullPath);
        next({ name: "login", params: { locale: userStore.getLanguage || localeParam || "es" } });
      }
    }
    return;
  } else if (
    userStore.isLoggedIn &&
    !to.matched.some((record) => record.meta.requiresAuth) &&
    !to.matched.some((record) => record.meta.isAmbiguous)
  ) {
    //console.info("This is a public route, user should not be here:", to.name);
    next({
      name: "home-app",
      params: { locale: userStore.getLanguage || localeParam || "es" },
    });
    return;
  }

  next();
});

export default router;
